export const APP_CONFIG = {
  scheme: 'riddleme',
  package: 'com.riddleme.app.v2',
  name: 'RiddleMe',
  iosStoreUrl: 'https://apps.apple.com/gb/app/riddleme-the-daily-riddle/id6757712671',
  androidStoreUrl: 'https://play.google.com/store/apps/details?id=com.riddleme.app.v2',
};

export function getPlatform() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return 'desktop';
}

/**
 * Returns true when the page is running inside an in-app browser or WebView
 * rather than the device's real browser (Chrome, Safari).
 *
 * Android: Chrome adds "Chrome/" but NOT "wv". WebViews add "wv".
 * iOS:     Real Safari always includes "Safari/". WebViews (WKWebView) omit it.
 * Both:    Catch known social-app tokens as a belt-and-braces fallback.
 */
export function isInAppBrowser() {
  const ua = navigator.userAgent || '';

  // Known in-app browser tokens
  if (/FBAN|FBAV|FB_IAB|FBIOS|Instagram|LinkedInApp|Snapchat|Twitter|TikTok/.test(ua)) {
    return true;
  }

  const platform = getPlatform();

  if (platform === 'android') {
    // Real Chrome on Android: has "Chrome/" but not the WebView flag "wv"
    return /wv/.test(ua) || !/Chrome\//.test(ua);
  }

  if (platform === 'ios') {
    // Real Safari always has "Safari/" in the UA. WebViews (WKWebView) do not.
    return !/Safari\//.test(ua);
  }

  return false;
}

export function getStoreUrl(platform) {
  return platform === 'ios' ? APP_CONFIG.iosStoreUrl : APP_CONFIG.androidStoreUrl;
}

export function buildAndroidIntentUrl(deepLinkUrl) {
  const rest = deepLinkUrl.replace(`${APP_CONFIG.scheme}://`, '');
  const fallback = encodeURIComponent(APP_CONFIG.androidStoreUrl);
  return `intent://${rest}#Intent;scheme=${APP_CONFIG.scheme};package=${APP_CONFIG.package};S.browser_fallback_url=${fallback};end`;
}
